import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { SM_CONSTANTS } from "../../constants/sm-constants";
import { FormControl } from "@angular/forms";
import { COUNTRY_CODES } from "../../data/country-codes";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { ApiService } from "src/app/providers/api.service";
import { CustomConfirmDialogComponent } from "../custom-confirm-dialog/custom-confirm-dialog.component";
import { Subscription } from "rxjs";
import { AlertForEmailComponent } from "../alert-for-email/alert-for-email.component";
@Component({
  selector: 'sm-ask-business-rating',
  templateUrl: './ask-business-rating.component.html',
  styleUrls: ['./ask-business-rating.component.scss']
})
export class AskBusinessRatingComponent implements OnInit, OnDestroy {
  msg: any;
  copied: boolean = false;
  selectedValue: any = "1";
  whatsappNumbers: any = "";
  emailAddresses: any = "";
  apisub: Subscription;
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private loaderservice: LoaderServiceService,
    private apiservice: ApiService,
    private _modelRef: MatDialog,
  ) {
    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_SEND_REVIEW_REQUEST_VIA_EMAIL
      ) {
        if (resdata.result) {
          this.loaderservice.showLoader = false;
          // this.whatsappNumbers = "";
          // this.emailAddresses = "";
          if (
            resdata.result.unsuccessfull_emails &&
            resdata.result.unsuccessfull_emails.length > 0
          ) {
            const dialogRef1 = this._modelRef.open(AlertForEmailComponent, {
              width: "600px",
              data: {
                title: "Details shared successfully.",
                message1: "Details shared successfully.",
                message2: resdata.result.unsuccessfull_emails.join(", "),
                message3:
                  "The following recipient unsubscribed to email sending from LookzUp platform. Contact support to send him/her email.",
                okbtn: "Ok",
                cancelbtn: "Cancel",
                type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
              },
              disableClose: true,
            });
          } else {
            this._modelRef.open(CustomConfirmDialogComponent, {
              width: "600px",
              data: {
                title: "Details shared successfully.",
                message: "Details shared successfully.",
                okbtn: "Ok",
                cancelbtn: "Cancel",
                type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
              },
              disableClose: true,
            });
          }
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_SEND_REVIEW_REQUEST_VIA_WHATSAPP
      ) {
        if (resdata.result) {
          this.loaderservice.showLoader = false;
          // this.whatsappNumbers = "";
          // this.emailAddresses = "";
          this._modelRef.open(CustomConfirmDialogComponent, {
            width: "600px",
            data: {
              title: "Details shared successfully.",
              message: "Details shared successfully.",
              okbtn: "Ok",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
        }
      }
    });
  }
  referenceData: any;
  ngOnInit(): void {
    console.log(this.parentData.data);
    this.msg = this.parentData.data;
    this.referenceData = this.parentData.reference;

    this.whatsappNumbers = this.referenceData?.customer_phone;
    this.selectedCountryCode = this.countryList.find(
      (country) => country.dial_code === this.referenceData?.country_code,
    );
    this.emailAddresses = this.referenceData?.email;
  }

  copyInputMessage(inputElement: any) {
    inputElement.select();
    document.execCommand("copy");
    inputElement.setSelectionRange(0, 0);
    this.copied = true;
  }

  inviteType: "whatsapp" | "email" = "whatsapp";

  // NEW FUNCTIONS
  changeChip(value: any) {
    // this.whatsappNumbers = "";
    // this.emailAddresses = "";
    this.selectedValue = value;
  }

  countryList: {
    name: string;
    dial_code: string;
    code: string;
    flag: string;
    preferred?: any;
  }[] = COUNTRY_CODES;
  selectedCountryCode: any = this.countryList.find(
    (country) => country.dial_code === "+91",
  );

  searchString: FormControl = new FormControl("");
  onCountrySelected(event: any): void {
    this.searchString.reset();
    this.countryList = COUNTRY_CODES;
  }

  onKey() {
    console.log(this.searchString.value);

    this.countryList = [];
    this.selectSearch(this.searchString.value);
  }
  selectSearch(value: string) {
    let filter = value.toLowerCase();
    for (let i = 0; i < COUNTRY_CODES.length; i++) {
      let option = COUNTRY_CODES[i];
      if (option.name.toLowerCase().indexOf(filter) >= 0) {
        this.countryList.push(option);
      }
    }
  }

  checkdis() {
    if (this.selectedValue == "1") {
      if (
        this.whatsappNumbers &&
        this.whatsappNumbers.trim() != "" &&
        this.whatsappNumbers != undefined &&
        this.whatsappNumbers.length >= 3 &&
        this.whatsappNumbers.length <= 17
      ) {
        return false;
      } else {
        return true;
      }
    } else if (this.selectedValue == "2") {
      if (
        !this.emailAddresses ||
        this.emailAddresses.trim() === "" ||
        this.emailAddresses == undefined
      ) {
        return true;
      }
      // Clean and split the email addresses
      let cleanedEmails = this.emailAddresses
        .replace(/^[,\s]+|[,\s]+$/g, "")
        .replace(/\s*,\s*/g, ",")
        .split(",");

      // Check for invalid emails
      let hasInvalidEmail = cleanedEmails.some(
        (email: any) => !this.isValidEmail(email),
      );

      // Disable if any invalid email exists
      return hasInvalidEmail;
    }
    return true; // Default disable
  }

  isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  send() {
    if (this.selectedValue == "1") {
      this.loaderservice.showLoader = true;

      // Remove leading and trailing commas and spaces
      this.whatsappNumbers = this.whatsappNumbers.replace(
        /^[,\s]+|[,\s]+$/g,
        "",
      );

      // Ensure that spaces after commas are removed
      // this.whatsappNumbers = this.whatsappNumbers.replace(/\s*,\s*/g, ",");

      // let splittedNumbers = this.whatsappNumbers.split(",");
      // let countryCode = this.selectedCountryCode.dial_code;
      // countryCode = countryCode.slice(1);

      // let formattedNumbers = splittedNumbers.map((item: any) => {
      //   return countryCode.concat(item);
      // });

      let obj = {
        customer_name: this.referenceData?.customer_name,
        phone: this.whatsappNumbers,
        country_code: this.selectedCountryCode.dial_code,
        entity_hash: this.parentData.entity_hash,
        type: this.parentData.type,
        appointment_no: this.referenceData?.appointment_no ?? "---",
        services: "spa, massage",
        date: this.referenceData?.bookingDate
          ? this.formatDateTime(this.referenceData?.bookingDate)
          : this.formatDateTime(new Date()), //check
        reference_hash: this.referenceData?.hash_id,
      };
      console.log(obj);

      this.apiservice.sendReviewRequestViaWhatsApp(obj);
    } else if (this.selectedValue == "2") {
      // Remove leading and trailing commas and spaces
      this.emailAddresses = this.emailAddresses.replace(/^[,\s]+|[,\s]+$/g, "");
      
      // Ensure that spaces after commas are removed
      this.emailAddresses = this.emailAddresses.replace(/\s*,\s*/g, ",");

      let emailContents = this.emailAddresses.split(",");

      if (emailContents.length > 1) {
        this._modelRef.open(CustomConfirmDialogComponent, {
          width: "500px",
          data: {
            title: "Alert",
            message:
              "You can send maximum 1 payment intimation E-mail at once. Send the extra ones in another try.",
            okbtn: "Ok",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
          },
          disableClose: true,
        });
      } else {
        this.loaderservice.showLoader = true;
        let obj = {
          customer_name: this.referenceData?.customer_name,
          type: this.parentData.type,
          appointment_no: this.referenceData?.appointment_no ?? "---",
          services: "spa, massage",
          date: this.referenceData?.bookingDate
            ? this.formatDateTime(this.referenceData?.bookingDate)
            : this.formatDateTime(new Date()), //check
          reference_hash: this.referenceData?.hash_id,
          email: this.emailAddresses,
          entity_hash: this.parentData.entity_hash,
        };

        console.log(obj);

        this.apiservice.sendReviewRequestViaEmail(obj);
      }
    }
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }

  formatDateTime(isoString: any) {
    const date = new Date(isoString);

    // We use Intl.DateTimeFormat for a clean, localized string
    return new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }).format(date);
  }
}
